import styled from "styled-components";

const Subtitle = styled.h2`
  display: flex;
  font-weight: 100;
  font-size: 1.2rem;
  margin-top: 0;
  color: ${props => props.theme.colors.black};
`
export default Subtitle;
